import React, { useState, useEffect } from "react";
import {
  getPopupRegistration,
  openPopup,
  Priority,
} from "app/PopupHolder";
import CommonModal from "components/base/CommonModal";
import Button, { SolidButton } from "components/Button";
import { UserTypeMap } from 'data/user/constants';
import css from "./style.scss";
import userIcon from 'assets/images/account-page/user-icon.png';

const AssignTeamMemberModal = (props) => {
  const {
    teamMembers = [],     // [{ id, name, email, role }]
    assignedUsers = [],
    loading,
    onSave,
    closePopup,
  } = props;

  const [selectedUsers, setSelectedUsers] = useState([]);

  useEffect(() => {
    setSelectedUsers(assignedUsers);
  }, [assignedUsers]);

  const toggleUser = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id)
        ? prev.filter((uid) => uid !== id)
        : [...prev, id]
    );
  };

  const handleSave = () => {
    onSave?.(selectedUsers);
    closePopup();
  };

  const isDirty =
    selectedUsers.slice().sort().join(",") !==
    assignedUsers.slice().sort().join(",");

  return (
    <CommonModal
      onClose={closePopup}
      className={css.modal}
      closeOnBackdrop={false}
    >
      <div className={css.modalTitle}>Assign Team Member</div>

      <div className={`${css.listWrapper} ${teamMembers.length > 5 ? css.withScrollbar : ""}`}>
        {teamMembers.map((user) => {
          const isSelected = selectedUsers.includes(user.id);

          return (
            <div
              key={user.id}
              className={`${css.userRow} ${isSelected ? css.selectedRow : ""}`}
            >
              <div className={css.userLeft}>
                {/* <div className={css.avatar}>
                  <SVG icon="userIcon" />
                </div> */}
                <img
                  src={user?.logoUrl || userIcon}
                  alt="Profile"
                  className={css.avatar}
                  onError={(e) => {
                    e.currentTarget.onerror = null; // prevent infinite loop
                    e.currentTarget.src = userIcon;
                  }}
                />

                <div className={css.userInfo}>
                  <div className={css.name}>{user.fullName}</div>
                  <div className={css.email}>{user.username}</div>
                  <div className={css.role}>{user.type && UserTypeMap[user.type].label}</div>
                </div>
              </div>

              <button
                className={`${css.actionBtn} ${isSelected ? css.remove : css.add
                  }`}
                onClick={() => toggleUser(user.id)}
              >
                {isSelected ? "Remove" : "Add"}
              </button>
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div className={css.footer}>
        <Button onClick={closePopup} className={css.cancelSecondary}>Cancel</Button>
        <Button
          onClick={handleSave}
          disabled={!isDirty}
          loading={loading}
          className={css.btnPrimary}
        >
          Save
        </Button>
      </div>
    </CommonModal>
  );
};

/* Popup registration */
const registrationId = getPopupRegistration(AssignTeamMemberModal);

AssignTeamMemberModal.open = (props = {}) =>
  openPopup(registrationId, {
    ...props,
    priority: Priority.HIGH,
    closeOnBackdrop: false,
    closeAll: false,
  });

export default AssignTeamMemberModal;
